import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { FontAwesomeIcon } from 'components/Utils/FontAwesomeIconWrapper';
import { faClone, faTrash, faChevronRight, faEllipsis, faUsers } from '@fortawesome/pro-light-svg-icons';

import { Card, Flex, Tag, Dropdown, Button, Space, Tooltip } from 'antd';
import { ReadOnlyBadge } from 'components/ReadOnlyBadge';

import './ProjectItem.sass';

export const ProjectItem = (props: any) => {
	const { t } = useTranslation();

	// Projet partagé AVEC moi (je ne suis que lecteur) -> pas de suppression.
	const isReader = props?.details?.myRole === 'reader';
	// Projet partagé AVEC moi en éditeur : seul le propriétaire peut le cloner.
	const isEditor = props?.details?.myRole === 'editor';
	const readerCount = props?.details?.readerCount || 0;

	// Un lecteur n'a aucune action sur un projet partagé (ni cloner ni supprimer) :
	// le menu « ... » n'apparaît donc pas pour lui. Un éditeur ne voit pas
	// « cloner » (la Lambda refuse le clonage à tout autre que le propriétaire).
	const menuItems = isReader ? [] : [
		...(isEditor ? [] : [{
			key: 'clone',
			label: (
				<span onClick={props.onClone} style={{ opacity: !props.onClone ? 0.5 : 1 }}>
					{/* @ts-ignore */}
					<FontAwesomeIcon icon={faClone} style={{ marginRight: 8 }} />
					{t('models.project.actions.clone')}
				</span>
			),
			disabled: !props.onClone,
		}]),
		...([{
			key: 'delete',
			label: (
				<span onClick={props.onDelete} style={{ color: '#ff4d4f' }}>
					{/* @ts-ignore */}
					<FontAwesomeIcon icon={faTrash} style={{ marginRight: 8 }} />
					{t('models.project.actions.delete')}
				</span>
			),
		}]),
	];

	return (
		<Card className={"ProjectItem " + (isReader ? "shared " : "owned ") + (props?.className || "")} title={props?.details?.name} extra={
			<Space>

				{menuItems.length > 0 && (
					<Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
						<Button shape="circle" size="small">
							{/* @ts-ignore */}
							<FontAwesomeIcon icon={faEllipsis} />
						</Button>
					</Dropdown>
				)}

				<Tooltip title={t('models.project.actions.open')}>
					<Button
						shape="circle"
						size="small"
						onClick={() => props.onClick(props?.details?.id)}
					>
						{/* @ts-ignore */}
						<FontAwesomeIcon icon={faChevronRight} />
					</Button>
				</Tooltip>
			</Space>
		}>
			<Flex>
				{props?.details?.reference && <>
					<span className="reference">{props?.details?.reference}</span>
					&nbsp;-&nbsp;
				</>}

				<small>
					Created on{' '}
					{dayjs(props?.details?.createdAt).format('DD/MM/YYYY HH:mm')}
				</small>

				<div className="tagWrapper ml-auto" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					{isReader && (
						<Tooltip title={t('models.project.shared_with_me', { defaultValue: 'Partagé avec vous (lecture seule)' })}>
							<span style={{ display: 'inline-flex' }}><ReadOnlyBadge /></span>
						</Tooltip>
					)}

					{/* Compteur visible uniquement pour le propriétaire : un lecteur
					    n'a pas à savoir combien d'autres lecteurs il y a. */}
					{!isReader && readerCount > 0 && (
						<Tooltip title={t('models.project.readers_count', { count: readerCount, defaultValue: '{{count}} lecteur(s)' })}>
							<span className="readers">
								{/* @ts-ignore */}
								<FontAwesomeIcon icon={faUsers} style={{ marginRight: 4 }} />
								{readerCount}
							</span>
						</Tooltip>
					)}

					{props?.details?.type &&
						<Tag className="type" style={{ margin: 0 }}>
							{t("models.project.fields.types." + props?.details?.type)}
						</Tag>
					}
				</div>
			</Flex>
		</Card>
	);
};

export default ProjectItem;
